<app-navbar title="Piloci">
	<a routerLink="./add" class="btn btn-primary"> <i class="fas fa-plus"></i> Dodaj </a>
</app-navbar>

<app-tourist-guides-calendar-filters
	userFilters="touristGuidesList"
	[touristGuides]="parameters.touristGuide"
	[touristGuideTypes]="parameters.touristGuideType"
	(selected)="filtersSelected($event)"
></app-tourist-guides-calendar-filters>

<app-dynamic-table
	module="touristGuides"
	[elements]="data"
	[tableRows]="tableRows"
	(filtersClicked)="filtersOpen()"
></app-dynamic-table>
